import React from 'react';
import {BarChart3} from 'lucide-react';
import {AppTitle, AppText} from '../../../Presentation/components/ui/Typography';

/**
 * Welcome banner component for the main dashboard
 */
export const WelcomeBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-brand-200 rounded-lg p-8">
      <div className="flex items-center gap-6">
        <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center">
          <BarChart3 className="w-8 h-8 text-brand-600" />
        </div>
        <div>
          <AppTitle className="text-brand-900 mb-2">
            مرحباً بك في لوحة التحكم
          </AppTitle>
          <AppText className="text-brand-700">
            يمكنك الوصول إلى جميع الوحدات المتاحة لك من القائمة الجانبية
          </AppText>
        </div>
      </div>
    </div>
  );
};
